module.exports = __webpack_public_path__ + "static/media/adrian_stanek_02.124ac937.jpg";